/*!

=========================================================
* 　テンプレート
=========================================================
*/
import React from "react";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardTitle,
  Table,
  Row,
  Col,
  Modal, ModalBody, ModalFooter
} from "reactstrap";
import InputText from '../FormParts/InputText'
import InputSelect from '../FormParts/InputSelect'
import InputRadio from '../FormParts/InputRadio'
import SystemInfo from '../ViewParts/SystemInfo';
import CustomTd from '../ViewParts/CustomTd';
import InputNumber from '../FormParts/InputNumber'
import {
  cst_prefecture,
  cst_tax_in_flag,
  cst_due_day_rule,
  cst_fraction_amt_flag,
  cst_invoice_create_flag,
  cst_invoice_list_create_flag,
  cst_contract_create_flag,
  cst_payment_bank_account_type,
  cst_payment_due_rule_day,
  cst_invoice_customer_user_setting,
  cst_customer_branch_noname_flag,
  cst_invoice_bank,
  cst_invoice_list_create_type,
  cst_customer_system_flag,
  cst_customer_natural_flag,
  cst_customer_branch_reminder_send_flag,
  cst_auto_approval_flag,
  cst_customer_system_use_flag,
  cst_cu_customer_option_approval,
  cst_cu_customer_option_approval_step,
  DUE_DAY_RULE,
  cst_auto_order_display_flag,
  cst_dandori_work_use_flag,
  cst_dandori_work_original_item_number,
  cst_ex_genba_plus_use_flag,
  cst_ex_andpad_use_flag,
  cst_ex_andpad_quote_file_flag,
  cst_road_usage_permission_use_flag
} from '../../variables/codes_map';
import WithRole from '../FormParts/ButtonWithRole';
import Request from '../../common/Request';
import InputDatetime from "../FormParts/InputDatetime";
import GoogleDrive from  "../../common/GoogleDrive"
import format_url from '../../variables/format_url';
import custom_report from '../../variables/custom_report';
import { getErrorCodes, GetMessage, customMessages } from "../../variables/message";
import InputCheckBox from "../FormParts/InputCheckBox";
import { INVOICE_BANK } from "../../variables/invoice_bank"
import OptionConvert from '../../common/OptionConvert';
import ApprovedInfo from '../ViewParts/ApprovedInfo';
import AdminCustomerSelectPopup from '../ViewParts/AdminCustomerSelectPopup';
const moment = require("moment");

const domain = "";

class BranchRegist extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      valid: true,
      regist_modal: false,
      client_regist_modal: false,
      custom_report_modal: false,
      error_modal: false,
      customer_id:"",
      customer_branch_id:"",
      customer: [],
      customer_user:[],
      data: {
        values:{
          tax_in_flag : cst_tax_in_flag[0].default,
          fraction_amt_flag : cst_fraction_amt_flag[0].default,
          due_day_rule : cst_due_day_rule[0].default,
          invoice_create_flag : cst_invoice_create_flag[0].default,
          contract_create_flag : cst_contract_create_flag[0].default,
          payment_due_rule_month: 1,
          payment_due_rule_day : cst_payment_due_rule_day[0].default,
          invoice_customer_user_setting : cst_invoice_customer_user_setting[0].default,
          invoice_bank_name : cst_invoice_bank[0].default,
          customer_branch_reminder_send_flag : cst_customer_branch_reminder_send_flag[0].default
        },
        errors:{},
        requiredData:{}
      },
      pref_no : "1",
      rule_no : "",
      tax_in_flag: "",
      due_day: "",
      view: false,
      customer_user_data:[],
      bankList:[],
      bankBranchList:[],
      delete_target : "",
      edit_invoice_main_flag : false,
      landmark_user : [],
    };

    this.toggleRegistModal = this.toggleRegistModal.bind(this);
    this.toggleClientRegistModal = this.toggleClientRegistModal.bind(this);
    this.toggleCustomReportModal = this.toggleCustomReportModal.bind(this);
    this.validateCallback = this.validateCallback.bind(this)
    this.setFormatUrl = this.setFormatUrl.bind(this)
    this.alertNaturalIdCheck = this.alertNaturalIdCheck.bind(this);
    this.customer_select_popup = React.createRef();
    this.customerSelected = this.customerSelected.bind(this)
    this.GetCustomerLoginId = this.GetCustomerLoginId.bind(this)
  }

  // 初期ロード用
  componentDidMount()  {
    /*　ここは開発者が記述　*/
    //:customer_idは追加
    //:customer_branch_idは更新
    if(this.props.match.params.customer_id != undefined){ //追加
      const url = domain + '/api/customer/'+this.props.match.params.customer_id;
      Request.get(url,{},res => {
        if(res.Data.ulid){
          const customer_natural_id = res.Data.customer_natural_id
          
          const custom_estimate_format_object = Object.values(custom_report.estimate.survey).find((customObject)=>{
            return customObject.customer_natural_id == customer_natural_id
          })
          const custom_estimate_format_url = custom_estimate_format_object&&format_url[custom_estimate_format_object.format]

          const custom_invoice_format_object = custom_report.invoice.filter((customObject)=>!customObject.customer_branch_natural_id).find((customObject)=>{
            return customObject.customer_natural_id == customer_natural_id
          })
          const custom_invoice_format_url = custom_invoice_format_object&&format_url[custom_invoice_format_object.format]
          
          const custom_contract_format_object = custom_report.contract.find((customObject)=>{
            return customObject.customer_natural_id == customer_natural_id
          })
          const custom_contract_format_url = custom_contract_format_object&&format_url[custom_contract_format_object.format]

          const custom_invoice_list_format_object = custom_report.invoice_list.find((customObject)=>{
            return customObject.customer_natural_id == customer_natural_id
          })
          const custom_invoice_list_format_url = custom_invoice_list_format_object&&format_url[custom_invoice_list_format_object.format]

          // feature/1328 LANDMARK担当者の取得
          Request.get('/api/landmark/lastupdate', {}, resLast => {
            const landmark_user = OptionConvert.optionsById(resLast.Data)
            this.setState({
              landmark_user,
              data:{
                ...this.state.data,
                values:{
                  ...this.state.data.values,
                  ...res.Data,
                  c_customer_system_use_flag: res.Data.customer_system_use_flag, // 会社の顧客システム利用有無を引用
                  customer_system_use_flag: 0,
                  // customer_system_use_flag: res.Data.customer_system_use_flag == "1" ? 1 : 0, // 支店の顧客システム利用有無デフォルト値 ※res.Dataのcustom_system_use_flagは会社のなので上書き必須
                  customer_system_start_date: res.Data.customer_system_start_date,
                  customer_system_end_date: res.Data.customer_system_end_date,
                  customer_ulid:res.Data.ulid,
                  customer_natural_id,
                  dandori_work_use_flag: 0,
                  ...(custom_estimate_format_url
                    ?{estimate_format_url:custom_estimate_format_url}
                    :{}),
                  ...(custom_invoice_format_url
                    ?{invoice_format_url:custom_invoice_format_url}
                    :{}),
                  ...(custom_contract_format_url
                    ?{contract_format_url:custom_contract_format_url}
                    :{}),
                  ...(custom_invoice_list_format_url
                    ?{invoice_list_format_url:custom_invoice_list_format_url}
                    :{}),
                    ex_genba_plus_use_flag: 0,
                    ex_andpad_use_flag: 0,
                },
              },
              view:false
            }, this.setRequiredData);
          });
        }else{
          this.props.alertModal.current.showErrorModal({messageNo:2404});
        }
      });
    }else if(this.props.match.params.customer_branch_id != undefined){ //更新
      const url = domain + '/api/customer/branch/'+ this.props.match.params.customer_branch_id;
      Request.get(url,{},res => {
        if(res.Data.ulid){
          this.setState({
            data:{
              ...this.state.data,
              values:res.Data,
            },
            view:true
          });

          let lastUpdateUser = res.Data.lastupdate_user_id
          Request.get('/api/landmark/lastupdate', {}, res => {
            const landmark_user = OptionConvert.optionsById(res.Data)
            var url = domain + '/api/landmark/lastupdate/' + lastUpdateUser;
            Request.get(url, {}, res => {
              this.setState({
                landmark_user,
                data:{
                  ...this.state.data,
                  values:{
                    ...this.state.data.values,
                    lastupdate_user:res.Data,
                  }
                }
              });
            });
          })

          Request.get(domain + '/api/customer/user',{
            customer_branch_ulid:this.props.match.params.customer_branch_id,
            show_delete_data : 0
          },res => {
            this.setState({
              customer_user_data:res.Data.map((element)=>{
                return {
                  value:element.id,
                  label:element.customer_user_name,
                }
              })
            }, this.setRequiredData);
          });
        }else{
          this.props.alertModal.current.showErrorModal({messageNo:2404});
        }
      }); 
    }

    Request.get('/api/bank', {}, res=>{
      this.setState({
        bankList:res.Data.map(element=>{
          return {
            value:element.bank_name,
            label:element.bank_name,
            bank_name:element.bank_name
          }
        })
      });
    })
    Request.get('/api/bank/branch', {}, res=>{
      this.setState({
        bankBranchList:res.Data.map(element=>{
          return {
            value:element.bank_branch_name,
            label:element.bank_branch_name,
            bank_name:element.bank_name
          }
        })
      });
    })
    // スクロールバーを表示するように設定
    document.body.style.overflow = "auto";
  }

  componentDidUpdate(prevProps, prevState){
    if(this.state.data.values.customer_system_use_flag != prevState.data.values.customer_system_use_flag
      && this.state.data.values.customer_system_use_flag == "1" 
      && (prevState.data.values.customer_login_id == null || prevState.data.values.customer_login_id == "")
      ){
      this.GetCustomerLoginId(this.state.data)
    }
    if(this.state.data.values.customer_login_id != prevState.data.values.customer_login_id
      && (this.state.data.values.customer_login_id == ""))
    {
      this.props.alertModal.current.showErrorModal({
        title:'アラート',
        messageNo: (2499)
      });
      this.setState({
        data:{...prevState.data}
      })
    }
    
  }  

  customerSelected(customer, callback=()=>{}){
    const data = this.state.data;
    // console.log("customer", customer)
    const { 
      customer_user_email,
      customer_user_name,
      customer_user_name_kana,
      customer_reminder_sms_flag,
      customer_user_tel,
      customer_branch_id,
      customer_user_id,
     } = customer

    this.setState({
      data:{
        ...data,
        values:{
          ...data.values,
          admin_user_login_id:customer_user_email,
          login_id:customer_user_email,
          customer_user_name,
          customer_user_name_kana,
          customer_reminder_sms_flag,
          customer_user_tel,
          customer_branch_id,
          customer_user_id
        }
      }
    }, ()=>callback())
  }

  setRequiredData = async ()=>{
    const url = domain + '/api/customer/branch';
    const requiredCheckedData = await Request.getRequiredData(url, this.state.data)
    this.setState({
      data:requiredCheckedData
    })
  }

  toggleRegistModal() {
    this.setState({
      regist_modal: !this.state.regist_modal
    });
  }
  toggleClientRegistModal(){
    if(this.props.match.params.customer_branch_id != undefined){
      this.props.history.push('/customer?customer_natural_id='+this.state.data.values.customer_natural_id+'&customer_branch_natural_id='+this.state.data.values.customer_branch_natural_id);
    }else{
      this.setState({
        client_regist_modal: !this.state.client_regist_modal
      });
    }
  }
  toggleCustomReportModal(delete_target) {
    this.setState({
      custom_report_modal: !this.state.custom_report_modal,
      delete_target
    });
  }

  validate() {
    const {additional_amt, upper_limit_additional_amt} = this.state.data.values;
    
    let message = getErrorCodes(this.state.data.errors)

    if(additional_amt > upper_limit_additional_amt){
      message.push(2420)
    }
    if(message.length > 0){
      document.body.style.overflow = "auto";
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }

  async alertNaturalIdCheck(newData, callback=()=>{}){

    let tmpData = newData;
    let {customer_branch_natural_flag,customer_branch_natural_id_new} = tmpData.values;
    let customer_branch_natural_id_flag = true;
    
    if (customer_branch_natural_flag == "1" && customer_branch_natural_id_new != undefined && tmpData.errors.customer_branch_natural_id_new == undefined){

      await new Promise((resolve) => {
        const {
          customer_branch_natural_id_new,
        } = tmpData.values
        Request.get('/api/customer/branch/check',{customer_branch_natural_id:customer_branch_natural_id_new}
          , res => {
          console.log(res.Data);
          if(res.Data && res.Data == "NG"){
            customer_branch_natural_id_flag = false;
          }else{
            customer_branch_natural_id_flag = true;
          }
          resolve();
        },()=>{},()=>{},true,false)
      }).then(()=>{
        this.setState({
          data:{
            ...tmpData,
            requiredData : {
              ...tmpData.requiredData
            },
            errors : {
              ...tmpData.errors,
              customer_branch_natural_id_new: customer_branch_natural_id_flag == false? [GetMessage(2506)] : undefined,
            }
          }
        }, ()=>callback());
      });
    }else{
      console.log(customer_branch_natural_flag);
      if(customer_branch_natural_flag == "0"){
        tmpData.errors.customer_branch_natural_id_new = undefined;
        customer_branch_natural_id_new = "";
      }

      this.setState({
        data:{
          ...tmpData,
          values:{
            ...tmpData.values,
            customer_branch_natural_id_new
          },
          requiredData : {
            ...tmpData.requiredData
          },
          errors : {
            ...tmpData.errors,
            customer_branch_natural_id_new: tmpData.errors.customer_branch_natural_id_new ? tmpData.errors.customer_branch_natural_id_new : undefined,
          }
        }
      }, ()=>callback());
    }
  }
  
  alertDateCheck(newData){
    const {
      customer_system_start_date,
      customer_system_end_date
    } = newData.values
    const {
      customer_system_start_date:prev_customer_system_start_date,
    } = this.state.data.values
    if(customer_system_start_date && customer_system_end_date && (moment(customer_system_start_date) > moment(customer_system_end_date))){
      return {
        ...newData,
        errors:{
          ...newData.errors,
          ...{[(prev_customer_system_start_date === customer_system_start_date ? 'customer_system_end_date' : 'customer_system_start_date')]:[GetMessage(2492)]},
        }
      }
    }else{
      return newData
    }
  }

  validateCallback(newData, callback=()=>{}){
    const data = this.state.data;

    const before_invoice_bank_name = this.state.data.values.invoice_bank_name;
    const invoice_bank_name = newData.values.invoice_bank_name;
    let invoice_bank_account_number = newData.values.invoice_bank_account_number;
    
    let invoice_bank = {}
    let requiredData = {}
    let errors = {}

    let {
      invoice_list_create_flag,
      invoice_list_create_type,
      invoice_customer_user_setting,
      customer_branch_natural_flag,
      customer_branch_natural_id_new,
      customer_system_use_flag,
      dandori_work_use_flag,
      ex_genba_plus_use_flag,
      ex_andpad_use_flag,
    } = newData.values

    if (customer_branch_natural_id_new != this.state.data.values.customer_branch_natural_id_new 
      || customer_branch_natural_flag != this.state.data.values.customer_branch_natural_flag){
      this.alertNaturalIdCheck(newData,callback);
    }else{
      // 振込口座（ラジオを変更した場合、各銀行の初期値を設定する）
      if(before_invoice_bank_name !== invoice_bank_name){
        switch (invoice_bank_name) {
          case "三菱ＵＦＪ":
            invoice_bank = INVOICE_BANK.MITSUBISHI
            invoice_bank_account_number = invoice_bank.invoice_bank_account_number;
            requiredData = {
              invoice_bank_account_number : [GetMessage(2024)]
            }
            errors = {
              invoice_bank_account_number : [GetMessage(2024)]
            }
            break;
          case "三井住友":
            invoice_bank = INVOICE_BANK.SUMITOMO
            break;
          default:
            invoice_bank = INVOICE_BANK.NONE
            break;
        }
      } else {
        requiredData = {
          invoice_bank_account_number : undefined
        }
        errors = {
          invoice_bank_account_number : undefined
        }
      }

      // 締日:ルール（変更後の値）
      let new_due_day_rule = newData.values.due_day_rule;
      new_due_day_rule = typeof new_due_day_rule === "string" ? Number(new_due_day_rule) : new_due_day_rule

      // 締日日付（変更後の値）
      const new_due_day_rule_day = newData.values.due_day_rule_day;

      // 締日:ルールが日付指定の場合、必須設定
      if(new_due_day_rule === DUE_DAY_RULE.APPOINT_DATE){
        newData.requiredData.due_day_rule_day = [GetMessage(2024)]
        // 入力有りはエラー無、入力無しはエラー有を設定
        newData.errors.due_day_rule_day = new_due_day_rule_day ? undefined : [GetMessage(2024)]
      // 締日:ルールが日付指定以外の場合、必須設定を解除し、締日日付に入力していた値を削除
      }else{
        newData.errors.due_day_rule_day = undefined
        newData.requiredData.due_day_rule_day = undefined
        newData.values.due_day_rule_day = null
      }
      
      if (parseInt( invoice_list_create_flag )== 0) {
        invoice_list_create_type = 0
        newData.values.invoice_list_create_type = 0
      }

      newData.errors.invoice_list_create_type = (parseInt(invoice_list_create_type) == 1 && parseInt(invoice_customer_user_setting) == 0)?[GetMessage(2496)]:undefined
      newData.errors.invoice_customer_user_setting = (parseInt(invoice_list_create_type) == 1 && parseInt(invoice_customer_user_setting) == 0)?[GetMessage(2496)]:undefined

      if(customer_system_use_flag != this.state.data.values.customer_system_use_flag) {
        // newData.values.customer_system_start_date =  this.state.data.values.customer_system_start_date;
        // newData.values.customer_system_end_date =  this.state.data.values.customer_system_end_date;
        newData.values.customer_system_start_date = customer_system_use_flag == 0 ? null : this.state.data.values.c_customer_system_start_date;
        newData.values.customer_system_end_date = customer_system_use_flag == 0 ? null : this.state.data.values.c_customer_system_end_date;
      }
      var dateCheck = {}
      if(this.state.data.values.c_customer_system_use_flag == 1) {
        newData.requiredData.customer_system_start_date = customer_system_use_flag == 1 ? [GetMessage(2024)] : undefined
        newData.errors.customer_system_start_date = customer_system_use_flag == 1 && !newData.values.customer_system_start_date ? [GetMessage(2024)] : undefined
        dateCheck = this.alertDateCheck(newData)
      }
      if(dandori_work_use_flag == 1 && customer_system_use_flag == 1) {
        newData.requiredData.dandori_work_place_code = [GetMessage(2024)] 
        newData.requiredData.dandori_work_access_token = [GetMessage(2024)] 
        newData.requiredData.dandori_work_original_item_number = [GetMessage(2024)]
        if(!newData.errors.dandori_work_place_code) {
          newData.errors.dandori_work_place_code = newData.values.dandori_work_place_code ? undefined : [GetMessage(2024)]
        }
        if(!newData.errors.dandori_work_access_token) {
          newData.errors.dandori_work_access_token = newData.values.dandori_work_access_token ? undefined : [GetMessage(2024)]
        }
        if(!newData.errors.dandori_work_original_item_number) {
          newData.errors.dandori_work_original_item_number = typeof newData.values.dandori_work_original_item_number === 'number' ? undefined : [GetMessage(2024)]
        }
      }else{
        newData.errors.dandori_work_place_code = undefined;
        newData.values.dandori_work_access_token = null; //32文字の文字数制限以上の値が入っているとエラーになるため、リセット
        newData.errors.dandori_work_access_token = undefined;
        newData.errors.dandori_work_original_item_number = undefined;
      }
      if(ex_genba_plus_use_flag == 1 && customer_system_use_flag == 1) {
        newData.requiredData.ex_genba_plus_api_root_url = [GetMessage(2024)]
        if(!newData.errors.ex_genba_plus_api_root_url) {
          newData.errors.ex_genba_plus_api_root_url = newData.values.ex_genba_plus_api_root_url ? undefined : [GetMessage(2024)]
        }
      }else{
        newData.errors.ex_genba_plus_api_root_url = undefined;
      }
      if(ex_andpad_use_flag == 1 && customer_system_use_flag == 1) {
        newData.requiredData.ex_andpad_access_token_key = [GetMessage(2024)] 
        if(!newData.errors.ex_andpad_access_token_key) {
          newData.errors.ex_andpad_access_token_key = newData.values.ex_andpad_access_token_key ? undefined : [GetMessage(2024)]
        }
      }else{
        newData.errors.ex_andpad_access_token_key = undefined;
      }
      this.setState({
        data:{
          ...data,
          ...newData,
          ...dateCheck,
          values : {
            ...newData.values,
            ...dateCheck.values,
            ...invoice_bank,
            // customer_system_start_date: customer_system_use_flag == 0 ? null : this.state.data.values.c_customer_system_start_date,
            // customer_system_end_date: customer_system_use_flag == 0 ? null : this.state.data.values.c_customer_system_end_date,
          },
          errors : {
            ...newData.errors,
            ...dateCheck.errors,
            invoice_bank_account_number : invoice_bank_name !== "三菱ＵＦＪ" 
              ? undefined 
              : newData.errors.invoice_bank_account_number 
                ? newData.errors.invoice_bank_account_number 
                : (invoice_bank_account_number === null || invoice_bank_account_number === undefined || invoice_bank_account_number === "")
                  ? [GetMessage(2024)] 
                  : undefined,
          }
        }
      }, () => console.log(this.state.data))

    }

  }

  GetCustomerLoginId(newData){
    let {customer_login_id} = newData.values
    if ( customer_login_id == null || customer_login_id == ""){
      Request.get('/api/cu_customer_option/getid',{}, res => {

        newData.values.customer_login_id = res.Data
        this.setState({
          data:{...newData}
        })
      })    
  
    }
  }

  setFormatUrl(paramName, defaultUrl){
    Request.post('/api/report/copy',{
      format_url:defaultUrl
    },(res)=>{
      if (res.Data.sheet_id){
        this.validateCallback({
          ...this.state.data,
          values:{
            ...this.state.data.values,
            [paramName]:res.Data.sheet_id,
            [`${paramName}_not_saved_flag`]:true
          },
        })
      }
    }, (err)=>{

    })
  }
  clearFormatUrl(){
    const delete_target = this.state.delete_target
    this.setState({
      data : {
        ...this.state.data,
        values : {
          ...this.state.data.values,
          [delete_target] : null,
          [`${delete_target}_not_saved_flag`]:true
        }
      }
    })
  }

  regist() {
    const params = {
      ...this.state.data.values,
      invoice_customer_user:'',
      customer_ulid:this.state.data.values.customer_ulid,
      ...(this.state.data.values.invoice_customer_user_id?{invoice_customer_user_id:this.state.data.values.invoice_customer_user_id}:{})
    }
    const url = domain + '/api/customer/branch';
    if(this.state.view === false) {
      this.toggleRegistModal();
      Request.post(url, params, res => {
        if(res.Data.ulid){
          this.props.pageChangeAlert.current.inactivate();
          this.setState({
            customer_branch_id:res.Data.ulid,
            new_customer_branch_natural_id:res.Data.customer_branch_natural_id,
          }, ()=>this.toggleClientRegistModal());
        }else{
          this.props.alertModal.current.showErrorModal({messageNo:2402});
          if (res.Code!=800) {
            this.setState({
              data:{
                ...this.state.data,
                errors:res.Data,
              }
            }, ()=>{
              this.ButtonWithRole = WithRole(Button, this.props.buttons, this.state.view?this.state.data.values:undefined)
            })
          }
        }
      });
    } else {
      Request.put(url + "/" + this.props.match.params.customer_branch_id, params, res => {
        document.body.style.overflow = "auto";
        this.toggleRegistModal();
        if(res.Data.ulid){
          this.props.pageChangeAlert.current.inactivate();
          this.props.history.push(`/customer/detail/branch/${this.props.match.params.customer_branch_id}`) 
        }else{
          if (res.Code==801||res.Code==802||res.Code==803) {
            this.setState({
              data:{
                ...this.state.data,
                errors:res.Data,
              }
            }, ()=>{
              this.ButtonWithRole = WithRole(Button, this.props.buttons, this.state.view?this.state.data.values:undefined)
            })
          }
        }
      });
    }
  }

  button_name(){
    if(this.state.view === false){
      return "登録";
    }else{
      return "更新";
    }
  }

  set_title(){
    if(this.state.view === false){
      return "新規支店追加";
    }
    return "支店情報更新";
  }

  render() {
    // console.log('state', this.state)
    const ButtonWithRole = this.ButtonWithRole || WithRole(Button, this.props.buttons, this.state.view?this.state.data.values:undefined)
    const selectableBankBranch = this.state.bankBranchList.filter(element=>element.bank_name==this.state.data.values.invoice_bank_name)
    const employeeType =  parseInt(localStorage.employee_type)
    const isRegister = this.state.view === false ? false : true
    const customMessage = isRegister ? customMessages["customer_system_use_flag_branch"] : ""
    return (
      <>
        <div className="content">
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <CardTitle tag="h3">{this.set_title()}</CardTitle>
                </CardHeader>
                <Col md="11" className="detail">
                <ApprovedInfo
                  rootData={this.state.data}
                  validateCallback={this.validateCallback}
                  employeeType={employeeType}
                  visible={this.state.view}
                  isEdit={true}
                />  
                <SystemInfo
                        id_title='支店ID'
                        id_value={this.state.data.values.customer_branch_natural_id}
                        update_timestamp={this.state.data.values.update_timestamp}
                        update_user={this.state.data.values.lastupdate_user && this.state.data.values.lastupdate_user.name}
                        update_user_picture={this.state.data.values.lastupdate_user && this.state.data.values.lastupdate_user.picture}
                        visible={this.state.view} />  
                  <CardTitle tag="h4">管理情報</CardTitle>
                  <Table>
                    <tbody>
                      <tr>
                        <CustomTd 
                            label="ランドマーク担当者"
                            name='CUSTOMER_BRANCH__responsible_user_id'
                            copy={false}
                            rootData={this.state.data}
                            value={
                                <InputSelect 
                                label="営業担当"
                                rootData={this.state.data} 
                                isNull={true}
                                isSearchable={true}
                                validateType="regist" 
                                validateCallback={this.validateCallback}
                                options={this.state.landmark_user}
                              />
                            }
                        />
                      </tr>
                      <tr>
                        {/* <th>管理情報</th> */}
                        <CustomTd label='メモ'
                            name='CUSTOMER_BRANCH__system_memo'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputText multiline={true}
                                validateCallback={this.validateCallback} 
                                validateType='regist'
                              />
                            }
                        />
                      </tr>
                      {this.state.view === true && 
                        <tr>
                          <CustomTd label='削除フラグ'
                            name='CUSTOMER_BRANCH__delete_flag'
                            copy={false}
                            value={
                              <InputCheckBox 
                                validateCallback={this.validateCallback} 
                                checkedValue={1}
                                uncheckedValue={0}
                                rootData={this.state.data}
                              />
                            }
                          />
                        </tr>
                      }
                      <tr>
                        <CustomTd label='自動承認フラグ'
                          name='CUSTOMER_BRANCH__auto_approval_flag'
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputRadio
                              options={cst_auto_approval_flag}
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                        />
                      </tr>
                    </tbody>
                  </Table>                  
                  <CardTitle tag="h4">基本情報</CardTitle>
                  <Table>
                    <tbody>
                      <tr>
                        {/* <th rowSpan="2">会社情報</th> */}
                        <CustomTd label='会社名'
                          name='CUSTOMER__customer_name'
                          copy={false}
                          rootData={this.state.data}
                        />
                      </tr>
                      <tr>
                        <CustomTd label='会社名（カナ）'
                          name='CUSTOMER__customer_name_kana'
                          copy={false}
                          rootData={this.state.data} />
                      </tr>
                      {this.state.view === false &&
                      <tr>
                        <CustomTd label='支店ID手動設定'
                          name='CUSTOMER_BRANCH__customer_branch_natural_flag'
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputRadio
                              options={cst_customer_natural_flag}
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                        />                        
                      </tr>
                      }
                      {this.state.view === false &&
                      <tr>
                        {/* <th rowSpan="2">会社情報</th> */}
                        <CustomTd label='支店ID'
                          name='CUSTOMER_BRANCH__customer_branch_natural_id_new'
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputText
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                              hasKanaInput={true}
                              disabled={this.state.data.values.customer_branch_natural_flag == 1 ? false : true}
                            />
                          }
                        />
                      </tr>
                      }
                      <tr>
                        {/* <th rowSpan="4">支店情報</th> */}
                        <CustomTd label='支店名'
                            name='CUSTOMER_BRANCH__customer_branch_name'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputText
                                validateCallback={this.validateCallback} 
                                validateType='regist'
                                hasKanaInput={true}
                              />
                            }
                        />
                      </tr>
                      <tr>
                        <CustomTd label='支店名称無フラグ'
                          name='CUSTOMER_BRANCH__customer_branch_noname_flag'
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputRadio
                              options={cst_customer_branch_noname_flag}
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                        />
                      </tr>
                      <tr>
                        <CustomTd label='支店名（カナ）'
                            name='CUSTOMER_BRANCH__customer_branch_name_kana'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputText
                                validateCallback={this.validateCallback} 
                                validateType='regist'
                              />
                            }
                        />
                      </tr>       
                      <tr>
                        <CustomTd label='電話番号'
                            name='CUSTOMER_BRANCH__customer_branch_tel'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputText
                                validateCallback={this.validateCallback} 
                                validateType='regist'
                              />
                            }
                        />
                      </tr>                                        
                      <tr>
                        <CustomTd label='FAX番号'
                            name='CUSTOMER_BRANCH__customer_branch_fax'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputText
                                validateCallback={this.validateCallback} 
                                validateType='regist'
                              />
                            }
                        />
                      </tr>
                      <tr>
                        {/* <th rowSpan="5">所在地</th> */}
                        <CustomTd label='郵便番号'
                          name='CUSTOMER_BRANCH__customer_branch_zip_code'
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputText 
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                        />
                      </tr>
                      <tr>
                        <CustomTd label='都道府県'
                            name='CUSTOMER_BRANCH__customer_branch_prefecture'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputSelect
                              options={cst_prefecture}
                              validateCallback={this.validateCallback}
                              rootData={this.state.data} 
                              isSearchable={true}
                              isNull={true}
                              validateType="regist" 
                            />
                            }
                        />
                      </tr>
                      <tr>
                        <CustomTd label='市区町村'
                            name='CUSTOMER_BRANCH__customer_branch_city'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputText
                                validateCallback={this.validateCallback} 
                                validateType='regist'
                              />
                            }
                        />
                      </tr>
                      <tr>
                        <CustomTd label='番地（町名以降）'
                            name='CUSTOMER_BRANCH__customer_branch_address'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputText
                                validateCallback={this.validateCallback} 
                                validateType='regist'
                              />
                            }
                        />
                      </tr>
                      <tr>
                        <CustomTd label='調査見積時のCCメールアドレス'
                            name='CUSTOMER_BRANCH__customer_branch_cc_email'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputText
                                validateCallback={this.validateCallback} 
                                validateType='regist'
                              />
                            }
                        />
                      </tr>
                      <tr>
                        <CustomTd label='確定見積時のCCメールアドレス'
                            name='CUSTOMER_BRANCH__customer_branch_cc_email_quote'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputText
                                validateCallback={this.validateCallback} 
                                validateType='regist'
                              />
                            }
                        />
                      </tr>
                      <tr>
                        <CustomTd label='リマインド送信有無'
                            name='CUSTOMER_BRANCH__customer_branch_reminder_send_flag'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputRadio
                                options={cst_customer_branch_reminder_send_flag}
                                validateCallback={this.validateCallback} 
                                validateType='regist'
                              />
                            }
                        />
                      </tr>
                      <tr>
                        <CustomTd label='請求担当デフォルト設定'
                            name='CUSTOMER_BRANCH__invoice_customer_user_setting'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputRadio
                                options={cst_invoice_customer_user_setting}
                                disabled_options={this.state.data.values.invoice_list_create_type==1?[0]:[]}
                                validateCallback={this.validateCallback} 
                                validateType='regist'
                              />
                            }
                        />
                      </tr>
                      <tr>
                        {/* <th>請求担当</th> */}
                        <CustomTd label='請求担当'
                            name='CUSTOMER_BRANCH__invoice_customer_user_id'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputSelect
                                options={this.state.customer_user_data}
                                validateCallback={this.validateCallback} 
                                validateType='regist'
                                isSearchable={true}
                              />
                            }
                        />
                      </tr> 
                      <tr>
                        <CustomTd label='請求書送付先住所：郵便番号'
                            name='CUSTOMER_BRANCH__customer_branch_invoice_zip_code'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputText
                                validateCallback={this.validateCallback} 
                                validateType='regist'
                              />
                            }
                        />
                      </tr>
                      <tr>
                        <CustomTd label='請求書送付先住所：都道府県'
                            name='CUSTOMER_BRANCH__customer_branch_invoice_prefecture'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputSelect
                                options={cst_prefecture}
                                validateCallback={this.validateCallback}
                                rootData={this.state.data} 
                                isSearchable={true}
                                isNull={true}
                                validateType="regist" 
                              />
                            }
                        />
                      </tr>
                      <tr>
                        <CustomTd label='請求書送付先住所：市区町村'
                            name='CUSTOMER_BRANCH__customer_branch_invoice_city'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputText
                                validateCallback={this.validateCallback} 
                                validateType='regist'
                              />
                            }
                        />
                      </tr>
                      <tr>
                        <CustomTd label='請求書送付先住所：番地（町名以降）'
                            name='CUSTOMER_BRANCH__customer_branch_invoice_address'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputText
                                validateCallback={this.validateCallback} 
                                validateType='regist'
                              />
                            }
                        />
                      </tr>
                      <tr>
                        <CustomTd label='振込口座'
                          name='CUSTOMER_BRANCH__invoice_bank_name'
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputRadio
                              options={cst_invoice_bank}
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                        />
                      </tr>
                      <tr>
                        <CustomTd label='振込口座（支店名）'
                          name='CUSTOMER_BRANCH__invoice_bank_branch_name'
                          copy={false}
                          data={this.state.data.values}
                        />
                      </tr>
                      <tr>
                        <CustomTd label='振込口座（口座種別）'
                          name='CUSTOMER_BRANCH__invoice_bank_account_type'
                          copy={false}
                          data={this.state.data.values}
                        />
                      </tr>
                      <tr>
                        <CustomTd label='振込口座（口座番号）'
                          name='CUSTOMER_BRANCH__invoice_bank_account_number'
                          copy={false}
                          rootData={this.state.data}
                          value={
                            <InputText
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                              disabled={this.state.data.values.invoice_bank_name !== "三菱ＵＦＪ"}
                            />
                          }
                        />
                      </tr>
                      <tr>
                        <CustomTd label='振込口座（口座名義（カナ））'
                          name='CUSTOMER_BRANCH__invoice_bank_account_kana'
                          copy={false}
                          data={this.state.data.values}
                        />
                      </tr>
                      <tr>
                        <CustomTd label='自動発注機能'
                            name='CUSTOMER_BRANCH__auto_order_display_flag'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputRadio
                                options={cst_auto_order_display_flag}
                                validateCallback={this.validateCallback} 
                                validateType='regist'
                              />
                            }
                        />
                      </tr>
                    </tbody>
                  </Table>
                  <CardTitle tag="h4" className="float-left">クライアントルール</CardTitle>
                      <Table>
                        <tbody>
                            {/* <th rowSpan="8">見積ルール</th> */}
                          <tr>
                            <CustomTd label='上乗せ額'
                                name='CUSTOMER_BRANCH__additional_amt'
                                copy={false}
                                rootData={this.state.data}
                                value={
                                  <InputNumber
                                    unit="円" 
                                    validateCallback={this.validateCallback} 
                                    validateType='regist'
                                  />
                                }
                            />
                          </tr>
                          <tr>
                            <CustomTd label='上乗せ額の上限'
                                name='CUSTOMER_BRANCH__upper_limit_additional_amt'
                                copy={false}
                                rootData={this.state.data}
                                value={
                                  <InputNumber
                                    unit="円"
                                    validateCallback={this.validateCallback} 
                                    validateType='regist'
                                  />
                                }
                            />
                          </tr>                       
                          <tr>
                            <CustomTd label='手数料割引率（％）'
                                name='CUSTOMER_BRANCH__discount_rate'
                                copy={false}
                                rootData={this.state.data}
                                value={
                                  <InputNumber
                                  unit="%"
                                  validateCallback={this.validateCallback} 
                                  validateType='regist'
                                />
                                }
                            />
                          </tr>                       
                          <tr>
                            <CustomTd label='値引'
                                name='CUSTOMER_BRANCH__discount_amt'
                                copy={false}
                                rootData={this.state.data}
                                value={
                                  <InputNumber
                                    unit="円"
                                    validateCallback={this.validateCallback} 
                                    validateType='regist'
                                  />
                                }
                            />
                          </tr>                       
                          <tr>
                            <CustomTd label='税込フラグ'
                                name='CUSTOMER_BRANCH__tax_in_flag'
                                copy={false}
                                rootData={this.state.data}
                                value={
                                  <InputRadio
                                    options={cst_tax_in_flag}
                                    validateCallback={this.validateCallback} 
                                    validateType='regist'
                                  />
                                }
                            />
                          </tr>                       
                          <tr>
                            <CustomTd label='端数調整'
                                name='CUSTOMER_BRANCH__fraction_amt_flag'
                                copy={false}
                                rootData={this.state.data}
                                value={
                                  <InputRadio
                                    options={cst_fraction_amt_flag}
                                    validateCallback={this.validateCallback} 
                                    validateType='regist'
                                  />
                                }
                            />
                          </tr>                       
                          <tr>
                            {/* <th rowSpan="4">請求</th> */}
                            <CustomTd label='締日ルール'
                                name='CUSTOMER_BRANCH__due_day_rule'
                                copy={false}
                                rootData={this.state.data}
                                value={
                                  <InputRadio
                                    options={cst_due_day_rule}
                                    validateCallback={this.validateCallback} 
                                    validateType='regist'
                                  />
                                }
                            />
                          </tr>
                          <tr>
                            <CustomTd label='締日日付'
                                name='CUSTOMER_BRANCH__due_day_rule_day'
                                copy={false}
                                rootData={this.state.data}
                                value={
                                  <InputNumber
                                    // size={4}
                                    unit=" "
                                    disabled={this.state.data.values.due_day_rule!=4}
                                    validateCallback={this.validateCallback} 
                                    validateType='regist'
                                  />
                                }
                            />
                          </tr>                     
                          <tr>
                            <CustomTd label='支払期限日ルール：月'
                                name='CUSTOMER_BRANCH__payment_due_rule_month'
                                copy={false}
                                rootData={this.state.data}
                                value={
                                  <InputNumber
                                    unit="ヶ月後"
                                    validateCallback={this.validateCallback} 
                                    validateType='regist'
                                  />
                                }
                            />
                          </tr>
                          <tr>
                            <CustomTd label='支払期限日ルール：日'
                                name='CUSTOMER_BRANCH__payment_due_rule_day'
                                copy={false}
                                rootData={this.state.data}
                                value={
                                  <InputSelect
                                    options={cst_payment_due_rule_day}
                                    validateCallback={this.validateCallback}
                                    validateType='regist'
                                  />
                                }
                            />
                          </tr>
                          
                          <tr>
                            <CustomTd label='基本契約締結日（業務委託基本契約書）'
                                name='CUSTOMER_BRANCH__basic_contract_signing_date'
                                copy={false}
                                rootData={this.state.data}
                                value={
                                  <InputDatetime
                                    validateCallback={this.validateCallback} 
                                    validateType='regist'
                                  />
                                }
                            />
                          </tr>
                          <tr>
                            <CustomTd label='請求書作成：有無'
                                name='CUSTOMER_BRANCH__invoice_create_flag'
                                copy={false}
                                rootData={this.state.data}
                                value={
                                  <InputRadio
                                    options={cst_invoice_create_flag}
                                    validateCallback={this.validateCallback} 
                                    validateType='regist'
                                  />
                                }
                            />
                          </tr>
                          <tr>
                            <CustomTd label='一覧請求書作成：有無'
                                name='CUSTOMER_BRANCH__invoice_list_create_flag'
                                copy={false}
                                rootData={this.state.data}
                                value={
                                  <InputRadio
                                    options={cst_invoice_list_create_flag}
                                    validateCallback={this.validateCallback} 
                                    validateType='regist'
                                  />
                                }
                            />
                          </tr>
                          {/* 2021-11-26 feature/1041 */}
                          <tr>
                            <CustomTd label='一覧請求書作成：作成区分'
                                name='CUSTOMER_BRANCH__invoice_list_create_type'
                                copy={false}
                                rootData={this.state.data}
                                value={
                                  <InputRadio
                                    disabled={this.state.data.values.invoice_list_create_flag!=1}
                                    options={cst_invoice_list_create_type}
                                    validateCallback={this.validateCallback} 
                                    validateType='regist'
                                  />
                                }
                            />
                          </tr>                          
                          <tr>
                            <CustomTd label='契約書作成：有無'
                                name='CUSTOMER_BRANCH__contract_create_flag'
                                copy={false}
                                rootData={this.state.data}
                                value={
                                  <InputRadio
                                    options={cst_contract_create_flag}
                                    validateCallback={this.validateCallback} 
                                    validateType='regist'
                                  />
                                }
                            />
                          </tr>
                          <tr>
                            <CustomTd label='請求関係メモ'
                                name='CUSTOMER_BRANCH__invoice_memo'
                                copy={false}
                                rootData={this.state.data}
                                value={
                                  <InputText
                                    multiline={true}
                                    validateCallback={this.validateCallback} 
                                    validateType='regist'
                                  />
                                }
                            />
                          </tr>
                          <tr>
                            <CustomTd label='独自調査見積書フォーマットURL'
                              name='CUSTOMER_BRANCH__estimate_format_url'
                              copy={false}
                              rootData={this.state.data}
                              value={<>
                                { !this.state.data.values.estimate_format_url&&
                                  <ButtonWithRole
                                    button_id={this.state.view?"BTN_M1_09_04111":"BTN_M1_03_03871"}
                                    onClick={()=>this.setFormatUrl('estimate_format_url', GoogleDrive.getFormatUrl(format_url.C01_PDF))}
                                  >独自帳票作成</ButtonWithRole>
                                }
                                { this.state.data.values.estimate_format_url&&
                                  <>
                                    <a style={{marginRight:'5px'}} target="_blank" href={"https://docs.google.com/spreadsheets/d/"+this.state.data.values.estimate_format_url}>
                                      独自見積書フォーマット確認
                                    </a>
                                    <ButtonWithRole
                                      button_id={this.state.view?"BTN_M1_09_04114":"BTN_M1_03_03874"}
                                      size={'sm'}
                                      onClick={
                                        ()=>this.toggleCustomReportModal("estimate_format_url")
                                      }
                                    >削除</ButtonWithRole>
                                  </>
                                }
                                {
                                  this.state.view&&this.state.data.values.estimate_format_url_not_saved_flag
                                  &&<><br/><span>※まだ保存してないデータです。</span></>
                                }
                                </>
                              }
                            />
                          </tr>
                          <tr>
                            <CustomTd label='独自請求書フォーマットURL'
                              name='CUSTOMER_BRANCH__invoice_format_url'
                              copy={false}
                              rootData={this.state.data}
                              value={<>
                                { !this.state.data.values.invoice_format_url&&
                                  <ButtonWithRole
                                    button_id={this.state.view?"BTN_M1_09_04112":"BTN_M1_03_03872"}
                                    onClick={()=>this.setFormatUrl('invoice_format_url', GoogleDrive.getFormatUrl(format_url.G04_PDF))}
                                  >独自帳票作成</ButtonWithRole>
                                }
                                { this.state.data.values.invoice_format_url&&
                                <>
                                  <a style={{marginRight:'5px'}} target="_blank" href={"https://docs.google.com/spreadsheets/d/"+this.state.data.values.invoice_format_url}>
                                    独自請求書フォーマット確認
                                  </a>
                                  <ButtonWithRole
                                    button_id={this.state.view?"BTN_M1_09_04115":"BTN_M1_03_03875"}
                                    size={'sm'}
                                    onClick={
                                      ()=>this.toggleCustomReportModal("invoice_format_url")
                                    }
                                  >削除</ButtonWithRole>
                                </>
                                }
                                {
                                  this.state.view&&this.state.data.values.invoice_format_url_not_saved_flag
                                  &&<><br/><span>※まだ保存してないデータです。</span></>
                                }
                                </>
                              }
                            />
                          </tr>

                          <tr>
                            <CustomTd label='独自一覧請求書フォーマットURL'
                              name='CUSTOMER_BRANCH__invoice_list_format_url'
                              copy={false}
                              rootData={this.state.data}
                              value={<>
                                { !this.state.data.values.invoice_list_format_url&&
                                  <ButtonWithRole
                                    button_id={this.state.view?"BTN_M1_09_04117":"BTN_M1_03_03877"}
                                    onClick={()=>this.setFormatUrl('invoice_list_format_url',  GoogleDrive.getFormatUrl(format_url.G06_PDF))}
                                  >独自帳票作成</ButtonWithRole>
                                }
                                { this.state.data.values.invoice_list_format_url&&
                                <>
                                  <a style={{marginRight:'5px'}} target="_blank" href={GoogleDrive.getFormatUrl(this.state.data.values.invoice_list_format_url)}>
                                  独自一覧請求書フォーマット確認
                                  </a>
                                  <ButtonWithRole
                                    button_id={this.state.view?"BTN_M1_09_04118":"BTN_M1_03_03878"}
                                    size={'sm'}
                                    onClick={
                                      ()=>this.toggleCustomReportModal("invoice_list_format_url")
                                    }
                                  >削除</ButtonWithRole>
                                </>
                                }
                                {
                                  this.state.view&&this.state.data.values.invoice_list_format_url_not_saved_flag
                                  &&<><br/><span>※まだ保存してないデータです。</span></>
                                }
                                </>
                              }
                            />
                          </tr>

                          <tr>
                            <CustomTd label='独自契約書フォーマットURL'
                              name='CUSTOMER_BRANCH__contract_format_url'
                              copy={false}
                              rootData={this.state.data}
                              value={<>
                                { !this.state.data.values.contract_format_url&&
                                  <ButtonWithRole
                                    button_id={this.state.view?"BTN_M1_09_04113":"BTN_M1_03_03873"}
                                    onClick={()=>this.setFormatUrl('contract_format_url',  GoogleDrive.getFormatUrl(format_url.G05_PDF))}
                                  >独自帳票作成</ButtonWithRole>
                                }
                                { this.state.data.values.contract_format_url&&
                                <>
                                  <a style={{marginRight:'5px'}} target="_blank" href={GoogleDrive.getFormatUrl(this.state.data.values.contract_format_url)}>
                                    独自契約書フォーマット確認
                                  </a>
                                  <ButtonWithRole
                                    button_id={this.state.view?"BTN_M1_09_04116":"BTN_M1_03_03876"}
                                    size={'sm'}
                                    onClick={
                                      ()=>this.toggleCustomReportModal("contract_format_url")
                                    }
                                  >削除</ButtonWithRole>
                                </>
                                }
                                {
                                  this.state.view&&this.state.data.values.contract_format_url_not_saved_flag
                                  &&<><br/><span>※まだ保存してないデータです。</span></>
                                }
                                </>
                              }
                            />
                          </tr>
                        </tbody>
                      </Table>
                      {this.state.data.values.c_customer_system_use_flag==1&&<CardTitle tag="h4" className="float-left">顧客向けシステム利用情報</CardTitle>}
                      <Table>
                        <tbody>
                          {this.state.data.values.c_customer_system_use_flag==1&&
                            <tr>
                              <CustomTd label='顧客向け利用有無'
                                name='CUSTOMER_BRANCH__customer_system_use_flag'
                                copy={false}
                                rootData={this.state.data}
                                colSpan="8"
                                value={
                                  <InputRadio
                                    options={cst_customer_system_use_flag}
                                    validateCallback={this.validateCallback} 
                                    validateType='regist'
                                    // disabled={!isRegister}
                                    // customMessage={customMessage}
                                  />
                                }
                              />
                            </tr>
                          }
                          {this.state.data.values.c_customer_system_use_flag==1&&this.state.data.values.customer_system_use_flag==1&&<>
                            <tr>
                              <CustomTd label='顧客システム利用開始日'
                                  name='CUSTOMER_BRANCH__customer_system_start_date'
                                  copy={false}
                                  rootData={this.state.data}
                                  colSpan="8"
                                  value={
                                    <InputDatetime
                                      validateCallback={this.validateCallback} 
                                      validateType='regist'
                                    />
                                  }
                              />
                            </tr>
                            <tr>
                              <CustomTd label='顧客システム利用終了日'
                                  name='CUSTOMER_BRANCH__customer_system_end_date'
                                  copy={false}
                                  rootData={this.state.data}
                                  colSpan="8"
                                  value={
                                    <InputDatetime
                                      validateCallback={this.validateCallback} 
                                      validateType='regist'
                                    />
                                  }
                              />
                            </tr>
                            <tr>
                              <CustomTd label='道路使用許可利用有無'
                                  name='CUSTOMER_BRANCH__road_usage_permission_use_flag'
                                  copy={false}
                                  rootData={this.state.data}
                                  colSpan="4"
                                  value={
                                    <InputRadio
                                      options={cst_road_usage_permission_use_flag}
                                      validateCallback={this.validateCallback} 
                                      validateType='regist'
                                      disabled={false}
                                    />
                                  }
                              />
                            </tr>
                            <tr>
                              <CustomTd label='承認機能利用'
                                  name='CU_CUSTOMER_OPTION__approval'
                                  copy={false}
                                  rootData={this.state.data}
                                  colSpan="4"
                                  value={
                                    <InputRadio
                                      options={cst_cu_customer_option_approval}
                                      validateCallback={this.validateCallback} 
                                      validateType='regist'
                                      disabled={true}
                                    />
                                  }
                              />
                              {Number(this.state.data.values.approval) > 0 &&
                                <CustomTd label='承認の段階'
                                    name='CU_CUSTOMER_OPTION__approval_step'
                                    copy={false}
                                    rootData={this.state.data}
                                    colSpan="4"
                                    value={
                                      <InputRadio
                                        options={cst_cu_customer_option_approval_step}
                                        validateCallback={this.validateCallback} 
                                        validateType='regist'
                                        disabled={true}
                                      />
                                    }
                                />
                              }
                            </tr>
                            <tr>
                              <CustomTd label='会社ログインID'
                                  name='CU_CUSTOMER_OPTION__customer_login_id'
                                  copy={false}
                                  rootData={this.state.data}
                                  colSpan="8"
                                  value={
                                    <InputText
                                    rootData={this.state.data}
                                    validateCallback={this.validateCallback}
                                    validateType='regist'
                                    disabled={true}
                                  />
                                  }
                              />
                            </tr>
                            <tr>
                              <CustomTd label='システム管理者'
                                name='CU_CUSTOMER_OPTION__admin_user_login_id'
                                copy={false}
                                rootData={this.state.data}
                                colSpan="8"
                                value={
                                  <>
                                    <InputText
                                      rootData={this.state.data}
                                      label='システム管理者'
                                      name='CU_CUSTOMER_OPTION__admin_user_login_id'
                                      validateCallback={this.validateCallback} 
                                      validateType='regist'
                                      disabled={true}
                                    />
                                  </>
                                }
                              />
                            </tr>
                            <tr>
                              <CustomTd label='ダンドリワーク連携'
                                name='CUSTOMER_BRANCH__dandori_work_use_flag'
                                copy={false}
                                rootData={this.state.data}
                                colSpan="8"
                                value={
                                  <InputRadio
                                    options={cst_dandori_work_use_flag}
                                    validateCallback={this.validateCallback} 
                                    validateType='regist'
                                  />
                                }
                              />
                            </tr>
                            { this.state.data.values.dandori_work_use_flag != 0 &&
                            <>
                            <tr>
                              <CustomTd label='（ダンドリワーク連携）プレイスコード'
                                name='CUSTOMER_BRANCH__dandori_work_place_code'
                                copy={false}
                                rootData={this.state.data}
                                colSpan="8"
                                value={
                                  <InputText
                                    rootData={this.state.data}
                                    label='（ダンドリワーク連携）プレイスコード'
                                    name='CUSTOMER_BRANCH__dandori_work_place_code'
                                    validateCallback={this.validateCallback} 
                                    validateType='regist'
                                  />
                                }
                              />
                            </tr>
                            <tr>
                              <CustomTd label='（ダンドリワーク連携）アクセストークン'
                                name='CUSTOMER_BRANCH__dandori_work_access_token'
                                copy={false}
                                rootData={this.state.data}
                                colSpan="8"
                                value={
                                  <InputText
                                    rootData={this.state.data}
                                    label='（ダンドリワーク連携）アクセストークン'
                                    name='CUSTOMER_BRANCH__dandori_work_access_token'
                                    validateCallback={this.validateCallback} 
                                    validateType='regist'
                                  />
                                }
                              />
                            </tr>
                            <tr>
                              <CustomTd label='（ダンドリワーク連携）オリジナル項目　項目番号'
                                  name='CUSTOMER_BRANCH__dandori_work_original_item_number'
                                  copy={false}
                                  rootData={this.state.data}
                                  colSpan="8"
                                  value={
                                    <InputSelect
                                      options={cst_dandori_work_original_item_number}
                                      validateCallback={this.validateCallback}
                                      rootData={this.state.data} 
                                      isSearchable={true}
                                      isNull={true}
                                      validateType="regist" 
                                    />
                                  }
                              />
                            </tr>
                            </>}
                            <tr>
                              <CustomTd label='現場plus連携'
                                name='CUSTOMER_BRANCH__ex_genba_plus_use_flag'
                                copy={false}
                                rootData={this.state.data}
                                colSpan="8"
                                value={
                                  <InputRadio
                                    options={cst_ex_genba_plus_use_flag}
                                    validateCallback={this.validateCallback} 
                                    validateType='regist'
                                  />
                                }
                              />
                            </tr>
                            { this.state.data.values.ex_genba_plus_use_flag != 0 &&
                            <tr>
                              <CustomTd label='（現場plus連携）APIルートURL'
                                name='CUSTOMER_BRANCH__ex_genba_plus_api_root_url'
                                copy={false}
                                rootData={this.state.data}
                                colSpan="8"
                                value={
                                  <InputText
                                    rootData={this.state.data}
                                    label='（現場plus連携）APIルートURL'
                                    name='CUSTOMER_BRANCH__ex_genba_plus_api_root_url'
                                    validateCallback={this.validateCallback} 
                                    validateType='regist'
                                  />
                                }
                              />
                            </tr>
                            }
                            <tr>
                              <CustomTd label='ANDPAD連携'
                                name='CUSTOMER_BRANCH__ex_andpad_use_flag'
                                copy={false}
                                rootData={this.state.data}
                                colSpan="8"
                                value={
                                  <InputRadio
                                    options={cst_ex_andpad_use_flag}
                                    validateCallback={this.validateCallback} 
                                    validateType='regist'
                                  />
                                }
                              />
                            </tr>
                            { this.state.data.values.ex_andpad_use_flag != 0 &&
                            <>
                            <tr>
                              <CustomTd label='(ANDPAD)APIアクセストークン'
                                name='CUSTOMER_BRANCH__ex_andpad_access_token_key'
                                copy={false}
                                rootData={this.state.data}
                                colSpan="8"
                                value={
                                  <InputText
                                    rootData={this.state.data}
                                    label='(ANDPAD)APIアクセストークン'
                                    name='CUSTOMER_BRANCH__ex_andpad_access_token_key'
                                    validateCallback={this.validateCallback} 
                                    validateType='regist'
                                  />
                                }
                              />
                            </tr>
                            <tr>
                              <CustomTd label='確定見積書連携の有無'
                                name='CUSTOMER_BRANCH__ex_andpad_quote_file_flag'
                                copy={false}
                                rootData={this.state.data}
                                colSpan="8"
                                value={
                                  <InputRadio
                                    options={cst_ex_andpad_quote_file_flag}
                                    validateCallback={this.validateCallback} 
                                    validateType='regist'
                                  />  
                                }
                                />
                              </tr>
                            </>
                            }
                          </>}
                        </tbody>
                      </Table>
                  <Row md="12">
                    <Col md="6" className="text-center">
                      <Button color="secondary" onClick={() => { 
                        if(this.state.view === false){
                          this.props.history.push('/customer') 
                        } else {
                          this.props.history.push(`/customer/detail/branch/${this.props.match.params.customer_branch_id}`) 
                        }
                      }}>キャンセル</Button>
                    </Col>
                    <Col md="6" className="text-center">
                      <ButtonWithRole 
                        button_id={this.state.view?"BTN_M1_09_04130":"BTN_M1_03_03890"}
                        color="info" 
                        onClick={() => {
                          if(this.validate()){
                            this.toggleRegistModal()
                          }
                        }}
                      >
                        {this.button_name()}</ButtonWithRole>
                    </Col>
                  </Row>
                </Col>
              </Card>
            </Col>
          </Row>
        </div>
        <Modal isOpen={this.state.regist_modal} toggle={this.toggleRegistModal}>
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleRegistModal}>
              <i className="tim-icons icon-simple-remove"></i>
            </button>
            <h5 className="modal-title">{this.button_name()}</h5>
          </div>
          <ModalBody>
            <p>{this.button_name()}しますか？</p>
            {this.state.edit_invoice_main_flag && (<>
              <p>既に請求情報を設定している支店があります。</p>
            </>)}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggleRegistModal}>
              いいえ
            </Button>
            <ButtonWithRole 
              button_id={this.state.view?"BTN_M1_09_04150":"BTN_M1_03_03910"}
              color="info" 
              onClick={() => {this.regist();}}>
              はい
            </ButtonWithRole>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.client_regist_modal} toggle={this.toggleClientRegistModal}>
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleClientRegistModal}>
              <i className="tim-icons icon-simple-remove"></i>
            </button>
            <h5 className="modal-title">{this.button_name()}</h5>
          </div>
          <ModalBody>
            <p>支店を登録致しました。続いて担当者を登録しますか？</p>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => {this.toggleClientRegistModal(); this.props.history.push('/customer?customer_natural_id='+this.state.data.values.customer_natural_id+'&customer_branch_natural_id='+this.state.new_customer_branch_natural_id);}}>
              いいえ
            </Button>
            <Button color="info" onClick={() => { this.props.history.push('/customer/add/user/'+this.state.customer_branch_id) }}>
              はい
            </Button>
          </ModalFooter>
        </Modal>        
        
        <Modal isOpen={this.state.custom_report_modal} toggle={this.toggleCustomReportModal}>
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleCustomReportModal}>
              <i className="tim-icons icon-simple-remove"></i>
            </button>
            <h5 className="modal-title">{"削除"}</h5>
          </div>
          <ModalBody>
            <p>本当に削除してもよろしいですか、戻すことができません</p>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggleCustomReportModal}>
              いいえ
            </Button>
            <ButtonWithRole 
              button_id={this.state.view?"BTN_M1_09_04150":"BTN_M1_03_03910"}
              color="info" 
              onClick={() => {this.clearFormatUrl(); this.toggleCustomReportModal()}}>
              はい
            </ButtonWithRole>
          </ModalFooter>
        </Modal>
        <AdminCustomerSelectPopup 
          buttons={this.props.buttons}
          view={this.state.view}
          ref={this.customer_select_popup} 
          customerSelectedCallback={(customer)=>this.customerSelected(customer)}
          customerId={this.state.data.values.customer_ulid}
          customerBranchId={this.state.data.values.ulid}
          ignoreCustomerClick={true}
          ignoreCustomerBranchClick={true}
          {...this.props}
        />   
      </>
    );
  }
}

export default BranchRegist;
